import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconNordVPN = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="orange">
      <Path fill="#3E5FFF" d="M2.288 21.072C0.8 19.024 0 16.544 0 14.016C0 7.376 5.376 2 12 2C18.624 2 24 7.376 24 14.016C24 16.544 23.2 19.024 21.712 21.072L15.952 11.696L15.392 12.64L15.952 15.264L12 8.48L9.552 12.624L10.128 15.264L8.048 11.712L2.288 21.072Z"/>
    </IconWithGradient>);
};
